import React, { useState, useEffect } from 'react';
import SubCard from 'ui-component/cards/SubCard';
import {
  Grid,
  // MenuItem,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Box,
  // OutlinedInput,
  TextField,
  Alert,
  Snackbar,
  Autocomplete,
  Checkbox,
  Button,
  ButtonGroup,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
// import { LoadingButton } from '@mui/lab';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { AddDepartmentapi, AddDesignation, UpdateDepartment, ViewDepartment, ViewDesignation } from 'API/HrModule';
import { LoadingButton } from '@mui/lab';
// import { useNavigate } from 'react-router';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseIcon from '@mui/icons-material/Close';

const AddDepartment = () => {
  const [formData, setFormData] = useState({
    name: '',
    designations: [],
    newDesignation: ''
  });
  const [Success, setSuccess] = useState(false);
  const [Error, setError] = useState(false);
  const [errors, setErrors] = useState({});
  const [showNewDesignation, setShowNewDesignation] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [DesignationData, setDesignationData] = useState('');
  const [Open, setOpen] = useState(false);
  const [DepartmentData, setDepartmentData] = useState(null);
  const [EditData, setEditData] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));

    setErrors((prev) => {
      const updated = { ...prev };
      if (value && updated[field]) {
        delete updated[field];
      }
      return updated;
    });
  };

  const handleChangeEdit = (name, value) => {
    setEditData((prev) => ({
      ...prev,
      [name]: value
    }));
    if (name === 'department_id') {
      const selectedDept = DepartmentData?.find((d) => d._id === value);
      const designations = selectedDept ? selectedDept.designations.map((d) => d._id) : [];

      setEditData((prev) => ({
        ...prev,
        department_id: value,
        designation_ids: designations
      }));
    }
  };

  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };

  const handleAddNewDesignation = () => {
    setShowNewDesignation(true);
    // Clear designation dropdown value and error
    setFormData((prev) => ({ ...prev, designations: [], name: '' }));
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated.designations;
      delete updated.name;
      return updated;
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!showNewDesignation) {
      if (!formData.name.trim()) {
        newErrors.name = 'Department is required';
      }
    }

    if (showNewDesignation) {
      if (!formData.newDesignation.trim()) {
        newErrors.newDesignation = 'New Designation is required';
      }
    } else {
      if (formData.designations.length === 0) {
        newErrors.designations = 'At least one Designation is required';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      if (showNewDesignation) {
        AddDesignation(formData.newDesignation, setIsLoading, setSuccess, setError, setShowNewDesignation, setFormData, refunction);
      } else {
        AddDepartmentapi(formData, setIsLoading, setSuccess, setError, setShowNewDesignation, setFormData);
      }
    }
  };

  const handleUpdate = () => {
    UpdateDepartment(EditData, setIsLoading, setSuccess, setError, setOpen, refunctionDep);
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const refunction = () => {
    ViewDesignation(setIsLoading, setDesignationData, setError);
  };
  const refunctionDep = () => {
    ViewDepartment(setIsLoading, setDepartmentData, setError);
  };
  useEffect(() => {
    ViewDesignation(setIsLoading, setDesignationData, setError);
  }, []);
  useEffect(() => {
    if (Open) {
      ViewDepartment(setIsLoading, setDepartmentData, setError);
    }
  }, [Open]);

  return (
    <>
      {/* edit department */}
      <Dialog open={Open} fullWidth maxWidth="md">
        <DialogTitle variant="h3">Edit Designation</DialogTitle>
        <IconButton aria-label="close" onClick={() => setOpen(false)} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
              <FormControl required fullWidth>
                <InputLabel id="demo-select-small-label">Department</InputLabel>
                <Select
                  label="Department"
                  name="department_id"
                  value={EditData.edit}
                  onChange={(e) => handleChangeEdit('department_id', e.target.value)}
                >
                  <MenuItem value={'select'} disabled>
                    Select
                  </MenuItem>
                  {DepartmentData?.map((D) => (
                    <MenuItem value={D._id} key={D}>
                      {D.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xl={8} lg={8} md={6} sm={6} xs={12}>
              <Autocomplete
                multiple
                options={DesignationData && DesignationData}
                getOptionLabel={(option) => option.name}
                disableCloseOnSelect
                value={DesignationData && DesignationData?.filter((item) => EditData.designation_ids?.includes(item._id))}
                onChange={(e, value) =>
                  handleChangeEdit(
                    'designation_ids',
                    value.map((v) => v._id)
                  )
                }
                isOptionEqualToValue={(option, value) => option._id === value._id}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 5 }} checked={selected} />
                    {option.name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Designation"
                    placeholder="Select Designations"
                    fullWidth
                    onInput={handleInput}
                    error={Boolean(errors.designations)}
                    helperText={errors.designations}
                  />
                )}
                sx={{
                  '& .MuiAutocomplete-tag': { maxWidth: 150 },
                  '& .MuiOutlinedInput-root': { maxHeight: 'auto', overflowX: 'auto' }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            sx={{
              width: '20%',
              mr: 1,
              backgroundColor: '#592375',
              color: '#fff',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
            loading={IsLoading}
            color="secondary"
            onClick={handleUpdate}
            variant="contained"
          >
            Update
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={Error}
        autoHideDuration={5000}
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setError(false)} variant="filled" severity="error" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Success}
        autoHideDuration={5000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setSuccess(false)} variant="filled" severity="success" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <SubCard title={showNewDesignation ? 'Add Designation' : 'Add Department'}>
        <Grid container spacing={2}>
          <Grid item xl={12} md={12} sm={12}>
            <Grid container spacing={2}>
              {!showNewDesignation ? (
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Department"
                    required
                    fullWidth
                    onInput={handleInput}
                    value={formData.name}
                    onChange={(e) => handleChange('name', e.target.value)}
                    error={Boolean(errors.name)}
                    helperText={errors.name}
                  />
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} md={8}>
                  <TextField
                    label="New Designation"
                    fullWidth
                    onInput={handleInput}
                    value={formData.newDesignation}
                    onChange={(e) => handleChange('newDesignation', e.target.value)}
                    error={Boolean(errors.newDesignation)}
                    helperText={errors.newDesignation}
                  />
                </Grid>
              )}

              {/* Designation Dropdown */}
              {!showNewDesignation && (
                <Grid item xs={12} sm={6} md={8}>
                  <Autocomplete
                    multiple
                    options={DesignationData && DesignationData}
                    getOptionLabel={(option) => option.name}
                    disableCloseOnSelect
                    value={DesignationData && DesignationData.filter((item) => formData.designations.includes(item._id))}
                    onChange={(e, value) =>
                      handleChange(
                        'designations',
                        value.map((v) => v._id)
                      )
                    }
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 5 }} checked={selected} />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Designation"
                        placeholder="Select Designations"
                        fullWidth
                        onInput={handleInput}
                        error={Boolean(errors.designations)}
                        helperText={errors.designations}
                      />
                    )}
                    sx={{
                      '& .MuiAutocomplete-tag': {
                        maxWidth: 150 // Optional: limit tag width
                      },
                      '& .MuiOutlinedInput-root': {
                        maxHeight: 'auto', // Control height
                        overflowX: 'auto'
                      }
                    }}
                  />
                </Grid>
              )}

              {/* New Designation Field */}
              {/* {showNewDesignation && (
                <Grid item xs={12} sm={6} md={8}>
                  <TextField
                    label="New Designation"
                    fullWidth
                    onInput={handleInput}
                    value={formData.newDesignation}
                    onChange={(e) => handleChange('newDesignation', e.target.value)}
                    error={Boolean(errors.newDesignation)}
                    helperText={errors.newDesignation}
                  />
                </Grid>
              )} */}

              {/* Add Designation Button */}
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                  <ButtonGroup>
                    {!showNewDesignation && (
                      <Button
                        size="small"
                        sx={{
                          borderColor: '#688B3A',
                          color: '#688B3A',
                          borderRadius: '6px',
                          '&:hover': {
                            borderColor: '#688B3A'
                          }
                        }}
                        color="secondary"
                        variant="outlined"
                        onClick={handleAddNewDesignation}
                      >
                        Add New Designation
                      </Button>
                    )}
                    <Button
                      color="secondary"
                      sx={{
                        borderColor: '#688B3A',
                        color: '#688B3A',
                        borderRadius: '6px',
                        '&:hover': {
                          borderColor: '#688B3A'
                        }
                      }}
                      size="small"
                      endIcon={<EditOutlinedIcon />}
                      onClick={() => setOpen(true)}
                    >
                      edit
                    </Button>
                  </ButtonGroup>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container display={'flex'} spacing={1} justifyContent={'center'} mt={2}>
          <Grid item>
            <Button
              variant="outlined"
              // sx={{ width: '240px' }}
              sx={{
                width: '240px',
                borderColor: '#592375',
                color: '#592375',
                mr: 1,
                borderRadius: '6px',
                '&:hover': {
                  borderColor: '#592375'
                }
              }}
              color="secondary"
              onClick={() => {
                // if (!showNewDesignation) {
                //   nav('/Admin/employee_onboard');
                // }
                setFormData({ name: '', designations: [], newDesignation: '' });
                setShowNewDesignation(false);
              }}
            >
              cancel
            </Button>
          </Grid>
          <Grid item>
            <LoadingButton
              loading={IsLoading}
              variant="contained"
              sx={{
                width: '250px',
                backgroundColor: '#592375',
                color: '#FFFFFF',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#592375'
                }
              }}
              // sx={{ width: '250px' }}
              color="secondary"
              onClick={handleSubmit}
            >
              save
            </LoadingButton>
          </Grid>
        </Grid>
      </SubCard>
    </>
  );
};

export default AddDepartment;
